import React from "react"

import { Box, Grid, Link } from "@material-ui/core"
import { EmblaCarouselType } from "embla-carousel"
import clsx from "clsx"

import { Banner } from "@/utils/banner"

import { useDotButton } from "@/hooks/useCarrouselDotButton"
import { DotButton } from "@/pages/Admin/Dashboard/Banners/BannersCarousel/BannerCarouselCard/DotButton"

import useStyles from "@/pages/Admin/Dashboard/Banners/BannersCarousel/BannerCarouselCard/styles"

type BannerCarouselCardProps = {
	banner: Banner
	emblaApi: EmblaCarouselType | undefined
	hasActiveCarrousel: boolean
}

const BannerCarouselCard: React.FC<BannerCarouselCardProps> = (props) => {
	const { banner, emblaApi, hasActiveCarrousel } = props

	const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi)

	const classes = useStyles()

	return (
		<Grid
			style={{
				flex: "0 0 100%",
				minWidth: "100%"
			}}
		>
			{banner.linkUrl ? (
				<Link
					href={banner.linkUrl}
					target={"_blank"}
					className={classes.bannerCardContainer}
				>
					<img
						src={banner.imageUrl}
						className={classes.bannerImg}
					/>
				</Link>
			) : (
				<Box className={classes.bannerCardContainer}>
					<img
						src={banner.imageUrl}
						className={classes.bannerImg}
					/>
				</Box>
			)}
			{hasActiveCarrousel && (
				<Grid className={classes.dotsContainer}>
					{scrollSnaps.map((_, index) => (
						<DotButton
							key={index}
							onClick={() => onDotButtonClick(index)}
							className={clsx({
								[classes.dot]: true,
								[classes.dotActive]: index === selectedIndex
							})}
						/>
					))}
				</Grid>
			)}
		</Grid>
	)
}

export default BannerCarouselCard
